function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { BannerAction, BannerTheme, BannerType } from 'common/components/banner/types';
import { BannerReact } from 'common/components/banner';
import { ButtonTheme } from 'common/components/button/constants';
import { reporter } from 'common/report/error-reporting';
import { BENCHMARK_PDF_URL } from 'common/constants';
import bannerStyleOverride from './banner.inline.styl';
import benchmarksSpotImg from './images/benchmarks-spot@2x.png';
type BenchmarkTemplateState = {
  visible: boolean;
};
export class BenchmarkTemplateBanner extends React.PureComponent<EmptyObj, BenchmarkTemplateState> {
  constructor(_props) {
    super(_props);
    _defineProperty(this, "localStorageKey", "benchmark-template-dismissed");
    this.state = {
      visible: null
    };
  }
  componentDidMount(): void {
    try {
      const dismissed = window.localStorage.getItem(this.localStorageKey);
      if (dismissed) {
        this.setState({
          visible: false
        });
      } else {
        this.setState({
          visible: true
        });
      }
    } catch (err) {
      reporter.warn(err, "Unable to retrieve ".concat(this.localStorageKey, " value from localStorage. User will continue to see the banner."));
    }
  }
  handleDismiss(): void {
    window.localStorage.setItem(this.localStorageKey, true.toString());
    this.setState({
      visible: false
    });
  }
  public render() {
    if (!this.state.visible) {
      return null;
    }

    // TODO: generalize DismissibleBanner so it can take other props like imgSrc and type
    return <BannerReact style-override={bannerStyleOverride} headerText={"2024 Benchmarks"} bodyText={"This template currently includes metrics from our 2024 Benchmarks campaign for you to view side by side with your own data. Download our official PDF to view even more insights. "} ctas={[{
      actionName: BannerAction.Dismiss,
      text: "Dismiss",
      trackEventName: "[Benchmarks] Dismiss Banner",
      trackProps: {
        source: "Banner"
      }
    }, {
      actionName: BannerAction.None,
      theme: ButtonTheme.Primary,
      text: "Download PDF",
      href: BENCHMARK_PDF_URL,
      download: true,
      trackEventName: "[Benchmarks] Download PDF",
      trackProps: {
        source: "Banner"
      }
    }]} imgSrc={benchmarksSpotImg} theme={BannerTheme.Base} type={BannerType.Embedded} onAction={ev => {
      if (ev.detail.actionName === BannerAction.Dismiss) {
        this.handleDismiss();
      }
    }} data-sentry-element="BannerReact" data-sentry-component="BenchmarkTemplateBanner" data-sentry-source-file="index.tsx" />;
  }
}